import { render } from "./UserVoice.vue?vue&type=template&id=7edf176d&scoped=true"
import script from "./UserVoice.vue?vue&type=script&lang=js"
export * from "./UserVoice.vue?vue&type=script&lang=js"

import "./UserVoice.vue?vue&type=style&index=0&id=7edf176d&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7edf176d"]])

export default __exports__